<div class="template-container" animate.enter="loaded-fade-enter">
  <h4 class="template-title">Plantillas de mensaje</h4>

  <div *ngIf="loading" class="loading-spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>

  <div *ngIf="!loading && !hasTemplates()" class="no-templates">
    <p class="text-muted">No hay plantillas disponibles</p>
  </div>

  <div *ngIf="!loading && hasTemplates()" class="template-layout">
    <!-- Lista de templates (izquierda) -->
    <div class="template-list">
      <div
        *ngFor="let template of templates"
        class="template-item"
        [class.selected]="selectedTemplate === template"
        (click)="selectTemplate(template)"
      >
        <span class="template-item-title">{{ template.Title }}</span>
      </div>
    </div>

    <!-- Contenido del template seleccionado (derecha) -->
    <div class="template-content">
      <div *ngIf="selectedTemplate" class="content-wrapper">
        <div class="content-header">
          <h5>{{ selectedTemplate.Title }}</h5>
        </div>
        <div class="content-body" [innerHTML]="selectedTemplate.Content"></div>
      </div>
    </div>
  </div>

  <!-- Botón Usar -->
  <div *ngIf="!loading && hasTemplates() && selectedTemplate" class="template-footer">
    <button class="btn btn-primary" (click)="useTemplate()" [disabled]="!selectedTemplate">
      <i class="fa fa-check"></i> Usar esta plantilla
    </button>
  </div>
</div>
